module.exports = __webpack_public_path__ + "img/logo_blue.4ccbe7f8.png";